// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sigCanvas {\n  border: 1px solid black;\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/components/shop/AcceptAndSignDialog/AcceptAndSignDialog.css"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,WAAA;AACF","sourcesContent":[".sigCanvas {\n  border: 1px solid black;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
